import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { FlowerSpinner } from 'react-epic-spinners';
import PropTypes from 'prop-types';

const ENCOURAGING_MESSAGES = [
  "Your next masterpiece is just one click away!",
  "Share a helpful tip and make a TikTok or Instagram reel.",
  "Turn a screen capture into a Pinterest graphic.",
  "Share links to your promotional reel on Reddit or Discord ",
  "There are billions of people with access to the internet; not everyone has seen your content.",
  "There are still eyes who haven't seen. Don't stop showing up and sharing.",
  "Do it again; post again. There's still someone out there who will appreciate your talent.",
  "Of all the stars in the universe and all of creation, somewhere on a lonely planet called Earth, there you are.",
  "You are truly amazing! Ready to create something special?",
  "Great ideas start with an empty canvas!",
  "The perfect time to start a new project!",
  "Every expert was once a beginner!",
  "You don't have to rely on talent, as long as you are willing to master a new skill.",
  "If you can imagine it, then there's gotta be a way.  Don't give up on your vision.",
  "Your creative journey begins here!",
  "What are you ready to tackle today?",
  "Dream it. Plan it. Build it.",
  "Let's turn ideas into reality!",
  "Good things await those who create!",
];

export const LoadingMessages = ({ showSpinner = true }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  
  const getRandomMessage = () => {
    const randomIndex = Math.floor(Math.random() * ENCOURAGING_MESSAGES.length);
    return ENCOURAGING_MESSAGES[randomIndex];
  };

  useEffect(() => {
    // Set initial message
    setMessage(getRandomMessage());
    
    // Set up interval to change message every 3 seconds
    const intervalId = setInterval(() => {
      setMessage(getRandomMessage());
    }, 5000);
    
    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleClick = () => {
    navigate('/price-predictor');
  };

  return (
    <div onClick={handleClick} style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '2rem',
      color: '#666',
      cursor: 'pointer',
    }}>
      {showSpinner && (
        <FlowerSpinner
          color="#5d1073" 
          size={70}
          style={{ marginBottom: '1.5rem' }}
        />
      )}
      <h2>Unlock the full features of your Dashboard with a badge!  </h2>
      <br />
    
      <p style={{ 
        marginTop: '0rem',
        maxWidth: '500px',
        lineHeight: '1.4',
        color: '#5d1073',
        textAlign:'center'
      }}>
        {message}
      </p>
    </div>
  );
};

LoadingMessages.propTypes = {
  showSpinner: PropTypes.bool
};